/**
 * @author sgdh & bly & gll & lifei
 * 功能：库存中心
 */

// 实体仓-仓
import { PhysicalWarehouseService } from './physicalWarehouse'

// 实体仓-仓区
import { WarehouseAreaService } from './warehouseArea'

// 实体仓-架位
import { FramePositionService } from './framePosition'

// 实体仓-柜组
import { groupService } from './group'

// 实体仓-区域配置
import { WhRegionService } from './whRegion'

// 调拨-转移单
import { TransferService } from './transfer'

// 调拨-转移单
import { WhSkuBatchStockService } from './whSkuBatchStock'

export const physicalWarehouse = new PhysicalWarehouseService('/api/stock/warehouse')

export const warehouseArea = new WarehouseAreaService('/api/stock/whArea')

export const framePosition = new FramePositionService('/api/stock/whRack')

export const group = new groupService('/api/stock/whCabinetGroup')

export const whRegion = new WhRegionService('/api/stock/whRegion')

// 上下架-上架单
import { frameUpService } from './frameUpDown/frameUp'
export const frameUp = new frameUpService('/api/stock/stockUpRackForm')

// 上下架-下架单
import { frameDownService } from './frameUpDown/frameDown'
export const frameDown = new frameDownService('/api/stock/downRackForm')

// 上下架-架位调整
import { rackAdjustmentService } from './frameUpDown/rackAdjustment'
export const rackAdjustment = new rackAdjustmentService('/api/stock/rackAdjustment')

// 上下架-库存查询
import { rackSkuStockService } from './frameUpDown/rackSkuStock'
export const rackSkuStock = new rackSkuStockService('/api/stock/rackSkuStock')

// 业务仓
import { BusinessManagementService } from './businessManagement'

export const ManagementService = new BusinessManagementService('/api/stock/bizWarehouse')

// 库存查询
import { bookInventoryInquiryService } from './bookInventoryInquiry'

export const bookInventoryInquiry = new bookInventoryInquiryService('/api/stock/search')
export const transfer = new TransferService('/api/stock/transfer')

export const whSkuBatchStock = new WhSkuBatchStockService('/api/stock/whSkuBatchStock')

import { CombiSplitFormService } from './combiSplitForm'

import { LossReportFormService } from './lossReportForm'

import { WhSkuStockService } from './whSkuStock'

import { BizWarehouseService } from './bizWarehouse'

import { StockReceiptTaskFormService } from './stockReceiptTaskForm'

import { DeliveryTaskFormService } from './deliveryTaskForm'

export const deliveryTaskForm = new DeliveryTaskFormService('/api/stock/deliveryTaskForm')

export const stockReceiptTaskForm = new StockReceiptTaskFormService('/api/stock/stockReceiptTaskForm')

export const combiSplitForm = new CombiSplitFormService('/api/stock/combiSplitForm')

export const lossReportForm = new LossReportFormService('/api/stock/lossReportForm')

export const whSkuStock = new WhSkuStockService('/api/stock/whSkuStock')

export const bizWarehouse = new BizWarehouseService('/api/stock/bizWarehouse')


// 领用单管理
import { RequisitionFormService } from './requisitionForm'
export const requisitionForm = new RequisitionFormService('/api/stock/requisitionForm')

// 报废通知单管理
import { ScrapNoticeService } from './scrapNotice'
export const scrapNotice = new ScrapNoticeService('/api/stock/scrapNotice')

// 报废单管理
import { ScrapService } from './scrap'
export const scrap = new ScrapService('/api/stock/scrap')

// 渠道仓管理
import { ChannelWarehouseService } from './channelWarehouse'
export const channelWarehouse = new ChannelWarehouseService('/api/stock/channelWarehouse')

// 预留占用单管理
import { ReserveFormService } from './reserveForm'
export const reserveForm = new ReserveFormService('/api/stock/reserveForm')

// 店铺仓管理
import { StoreWarehouseService } from './storeWarehouse'
export const storeWarehouse = new StoreWarehouseService('/api/stock/storeWarehouse')

// 收发货单管理
import { StockOutInService } from './stockOutIn'
export const stockOutIn = new StockOutInService('/api/stock/stockOutIn')

// 盈亏单管理
import { StockProfitLossFormService } from './stockProfitLossForm'
export const stockProfitLossForm = new StockProfitLossFormService('/api/stock/stockProfitLossForm')

// 渠道库存同步任务管理
import { ChannelStockTaskService } from './channelStockTask'
export const channelStockTask = new ChannelStockTaskService('/api/stock/channelStockTask')

// 渠道库存同步任务例外规则管理
import { ChannelStockTaskRuleService } from './channelStockTaskRule'
export const channelStockTaskRule = new ChannelStockTaskRuleService('/api/stock/channelStockTaskRule')

// 渠道库存同步任务例外规则日志管理
import { ChannelStockTaskRuleLogService } from './channelStockTaskRuleLog'
export const channelStockTaskRuleLog = new ChannelStockTaskRuleLogService('/api/stock/channelStockTaskRuleLog')

// 渠道库存同步任务日志管理
import { StockSyncTaskLogService } from './stockSyncTaskLog'
export const stockSyncTaskLog = new StockSyncTaskLogService('/api/stock/stockSyncTaskLog')

// 渠道库存管理
import { ChannelStockService } from './channelStock'
export const channelStock = new ChannelStockService('/api/stock/channelStock')
